import { ReactElement, useMemo, useState } from 'react'
import { ProviderType } from 'app/types/entities'
import { debug } from 'lib/logging'
import { lastNameInitial } from 'lib/nameUtils'

export function DisplayProviderAvatar({
  provider,
  fontSize = `10`,
}: {
  provider?: ProviderType
  fontSize?: string
}): ReactElement {
  const [imgError, setImgError] = useState<boolean>(false)
  const providerUrl = useMemo(() => {
    if (provider?.hasProfilePicture && provider?.id)
      return `https://trackable-${
        location.hostname.includes(`app.trackable.com`) ? `prod` : `dev`
      }-assets.s3.us-east-2.amazonaws.com/avatars/providers/${provider?.id}`
  }, [provider, location])
  const providerInitials = provider?.displayName ? provider.displayName[0] + lastNameInitial(provider.displayName) : `?`
  debug(`scheduling`, `DisplayProviderAvatar`, { provider, providerUrl, providerInitials })
  return !providerUrl || imgError ? (
    <div
      className="flex h-full w-full shrink-0 items-center justify-center rounded-[4px] border-[0.5px] border-danger-subtle bg-danger-subtle px-1 pb-[3px] pt-1 text-center align-middle text-ui-sm font-medium capitalize leading-3 text-danger-strong"
      style={{
        fontSize: `${fontSize}px`,
      }}
    >
      {providerInitials}
    </div>
  ) : (
    <img
      src={providerUrl}
      alt={provider?.displayName}
      className="aspect-square h-full w-full rounded-[4px]"
      onError={() => setImgError(true)}
    />
  )
}
